var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pencilclip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26551 19.5704L19.369 7.4669C20.877 5.95891 20.877 3.51398 19.369 2.00599C17.861 0.498003 15.4161 0.498003 13.9081 2.00599L1.8046 14.1095C1.6638 14.2503 1.56782 14.4296 1.52877 14.6249L0.520148 19.668C0.378996 20.3738 1.00124 20.996 1.70699 20.8549L6.75012 19.8462C6.94538 19.8072 7.12471 19.7112 7.26551 19.5704ZM15.0381 3.72776L17.6462 6.33585L17.9416 6.04043C18.6618 5.32023 18.6618 4.15255 17.9416 3.43234C17.2214 2.71214 16.0537 2.71214 15.3335 3.43234L15.0381 3.72776ZM13.6122 5.15313L3.44646 15.3189L2.79443 18.579L6.05454 17.9269L16.2203 7.76122L13.6122 5.15313Z",
    fill: "#3B968B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pencilclip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.a90cb4218e33f39688880383e3e9c2fe.svg";
export { ForwardRef as ReactComponent };